import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { catchError, mergeMap, of } from 'rxjs'

import { show_error_action } from '../action/common/common.action'
import { Expense, ExpenseReportAPIModel, PaginatedAPI } from 'src/models/api.model'
import { FETCH_EXPENSES, FETCH_EXPENSES_SUCCESS } from '../action/expense.action'
import { ExpenseService } from 'src/services/expense/expense.service'
import { FETCH_EXPENSE_REPORT_LIST, FETCH_EXPENSE_REPORT_LIST_SUCCESS } from '../action/expense.action'

@Injectable()
export class ExpenseEffects {
  constructor(private actions$: Actions, private expenseService: ExpenseService) {}

  fetch_past_executions_logs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_EXPENSE_REPORT_LIST),
      mergeMap(action =>
        this.expenseService.callGetExpenseReportApi(action).pipe(
          mergeMap((response: PaginatedAPI<ExpenseReportAPIModel>) => [
            FETCH_EXPENSE_REPORT_LIST_SUCCESS({ expenseReportList: response })
          ]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )

  fetch_expenses$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FETCH_EXPENSES),
      mergeMap(action =>
        this.expenseService.callGetExpensesApi({ payload: action.payload }).pipe(
          mergeMap((response: PaginatedAPI<Expense>) => [FETCH_EXPENSES_SUCCESS({ expenses: response })]),
          catchError((error: any) => of(show_error_action({ data: null, error: error })))
        )
      )
    )
  )
}
